import styled from "styled-components";
import { COLORS } from "../../../values/colors";

export const CartPageContainer = styled.div`
  width: 92%;
  max-width: 1200px;
  margin: 0 auto 5rem;
  padding-top: 6.2rem;

  @media (max-width: 1180px) {
    padding-top: 7.2rem;
  }

  @media (max-width: 720px) {
    padding-top: 8.3rem;
  }
`;

export const CartPageCard = styled.section`
  border: 1px solid ${COLORS.gray};
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.03);
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const CartPageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const CartPageTitle = styled.h2`
  margin: 0;
  font-size: clamp(1.35rem, 2.6vw, 2rem);
`;

export const CartPageHint = styled.p`
  margin: 0;
  color: ${COLORS.textSecondary};
  font-size: 0.9rem;
  line-height: 1.45;
`;

export const CartPageEmpty = styled.p`
  margin: 0;
  color: ${COLORS.textSecondary};
`;

export const CartPageList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const CartPageRow = styled.div`
  border: 1px solid ${COLORS.gray};
  border-radius: 0.7rem;
  padding: 0.7rem;
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
`;

export const CartPageRowInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: min(360px, 100%);

  @media (max-width: 560px) {
    min-width: 0;
  }
`;

export const CartPageRowName = styled.p`
  margin: 0;
  font-weight: 700;
`;

export const CartPageRowOptions = styled.p`
  margin: 0;
  color: ${COLORS.textSecondary};
  font-size: 0.9rem;
`;

export const CartPageRowActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-left: auto;

  @media (max-width: 560px) {
    width: 100%;
    margin-left: 0;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;

export const CartPageRowPrice = styled.p`
  margin: 0;
  font-weight: 700;
`;

export const QuantityRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.55rem;
`;

export const QuantityButton = styled.button`
  border: 1px solid ${COLORS.gray};
  background: transparent;
  color: ${COLORS.white};
  width: 1.95rem;
  height: 1.95rem;
  border-radius: 0.4rem;
  line-height: 1;
  font-size: 1.05rem;
  cursor: pointer;
`;

export const QuantityValue = styled.span`
  min-width: 1rem;
  text-align: center;
`;

export const RemoveButton = styled.button`
  border: 0;
  background: transparent;
  color: ${COLORS.textSecondary};
  text-decoration: underline;
  cursor: pointer;
`;

export const CartPageSummary = styled.div`
  border-top: 1px solid ${COLORS.gray};
  padding-top: 0.8rem;
  display: flex;
  justify-content: space-between;
  gap: 0.7rem;
  font-weight: 700;
  flex-wrap: wrap;

  @media (max-width: 560px) {
    flex-direction: column;
  }
`;
